document.addEventListener('DOMContentLoaded', function () {
    const buyButton = document.querySelector('buy-buttons button');
    const deviceIdInput = document.querySelector('[name="properties[Device ID]"]');
    const formControl = deviceIdInput.closest('.form-control');

    const buyButtonOriginalHTML = buyButton.innerHTML;

    // Create success icon element
    const successIcon = document.createElement('span');
    successIcon.className = 'device-id-success-icon';
    successIcon.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#22c55e" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 6L9 17l-5-5"/>
        </svg>
    `;
    successIcon.style.cssText = 'position:absolute;right:10px;top:50%;transform:translateY(-50%);display:none;line-height:0;';
    formControl.style.position = 'relative';
    formControl.appendChild(successIcon);

    // Create error message element
    const errorMessage = document.createElement('div');
    errorMessage.className = 'device-id-error-message';
    errorMessage.textContent = window.__deviceNotReleasedMessage || 'This Tool has not been released yet. Please contact your Master before purchasing this service.';
    errorMessage.style.cssText = 'color:#ef4444;font-size:0.85em;margin-bottom:6px;display:none;';
    formControl.parentNode.insertBefore(errorMessage, formControl);

    function showSuccess() {
        successIcon.style.display = 'block';
        errorMessage.style.display = 'none';
    }

    function showError() {
        successIcon.style.display = 'none';
        errorMessage.style.display = 'block';
    }

    function clearStatus() {
        successIcon.style.display = 'none';
        errorMessage.style.display = 'none';
    }

    function enableBuyButton() {
        buyButton.disabled = false;
        buyButton.style.opacity = 1;
        buyButton.innerHTML = buyButtonOriginalHTML;
    }

    function disableBuyButton() {
        buyButton.disabled = true;
        buyButton.style.opacity = 0.5;
        buyButton.innerHTML = buyButtonOriginalHTML;
    }

    function showBuyButtonLoading() {
        buyButton.disabled = true;
        buyButton.style.opacity = 0.7;
        buyButton.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="animation: spin 1s linear infinite;">
                <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
            </svg>
            <style>@keyframes spin { to { transform: rotate(360deg); } }</style>
        `;
    }

    async function checkDeviceReleased(deviceId) {
        showBuyButtonLoading();
        clearStatus();
        try {
            const baseUrl = window.__deviceApiUrl;
            if (!baseUrl) {
                console.error('Device API URL is not configured in theme settings.');
                disableBuyButton();
                showError();
                return;
            }

            console.log(`${baseUrl}`);
            console.log(`${baseUrl}/devices/${encodeURIComponent(deviceId)}/released`);
            const response = await fetch(
                `${baseUrl}/devices/${encodeURIComponent(deviceId)}/released`
            );
            const data = await response.json();
            if (data.is_released) {
                enableBuyButton();
                showSuccess();
            } else {
                disableBuyButton();
                showError();
            }
        } catch (error) {
            console.error('Error checking device release status:', error);
            disableBuyButton();
            showError();
        }
    }

    disableBuyButton();

    deviceIdInput.addEventListener('change', function () {
        const deviceId = deviceIdInput.value.trim();
        if (deviceId) {
            checkDeviceReleased(deviceId);
        } else {
            disableBuyButton();
            clearStatus();
        }
    });
});